import type { ReactElement, ReactNode } from "react";
import "./LaborCostSummaryItem.scss";

interface Props {
  icon: ReactNode;
  label: string;
  value: string;
}

export function LaborCostSummaryItem({
  icon,
  label,
  value,
}: Props): ReactElement {
  return (
    <div className="labor-cost-summary-item">
      <div className="item-icon">{icon}</div>
      <div className="item-label">{label}</div>
      <div className="item-value">{value} €</div>
    </div>
  );
}
